import Footer from "../components/Footer";

import About from "./About";
import Features2 from "../components/Features2";
import React, {useEffect} from "react";

import MetaComponent from "../components/MetaComponent";
import Header from "../components/Header";
import AboutUsCards from "./AboutUsCards";
import Features from "../home/Features";
import usePageReady from "../../shared/usePageReady";
const metadata = {
    title: `About Us || ${process.env.REACT_APP_META_TITLE}`,
    description: process.env.REACT_APP_META_DESCRIPTION,
};
export default function AboutUsPage({ onPageReady }) {
    usePageReady(onPageReady);
    return (
        <>
            <MetaComponent meta={metadata} />
            <Header />
            <About />
            <AboutUsCards />
            <Features />
            <Footer />
        </>
    );
}
